import { Component, Input } from "@angular/core";
import { TournamentService } from "../../providers/tournament.service";
import { ClubService } from "../../providers/club.service";
import { BvButtonSize, BvButtonComponent } from "../../design-system/primitives/button.component";

import { TranslateModule } from "@ngx-translate/core";

@Component({
    selector: "app-tournament-register-button",
    templateUrl: "./tournament-register-button.component.html",
    styles: [":host { display: contents; }"],
    imports: [BvButtonComponent, TranslateModule]
})
export class TournamentRegisterButtonComponent {
  @Input() tournament: any;
  @Input() size: BvButtonSize = "sm";

  constructor(
    public tournServ: TournamentService,
    public clubServ: ClubService
  ) {}

  isRegistered(): boolean {
    return this.tournServ.isRegisteredForTournament(this.tournament.tournID);
  }

  amFinished(): boolean {
    return this.tournServ.isFinishedInTournament(this.tournament.tournID);
  }

  // Mystery bounty: once the first bounty is drawn the prize pool is frozen, so
  // joining/leaving (which resizes it) is blocked. Computed from the passed
  // tournament (not latestTourn) since this button also renders in the lobby.
  bountyPoolLocked(t: any): boolean {
    const mode =
      t?.params?.bountyMode || (t?.params?.bountyTournament ? "fixed" : "none");
    if (mode !== "mystery") return false;
    const prizes = t?.mysteryPool?.prizes;
    if (!prizes) return false;
    const arr = Array.isArray(prizes) ? prizes : Object.values(prizes);
    return arr.some((p: any) => p && p.drawnBy);
  }

  canRegister(): boolean {
    const t = this.tournament;
    if (!t) return false;
    const reg = t.params?.registrations;
    // open: anyone; closed: staff only; fully_closed: nobody.
    const allowed =
      reg !== "fully_closed" && (reg !== "closed" || this.clubServ.clubStaff);
    return (
      !this.isRegistered() &&
      !!t.params?.manageRegistrations &&
      allowed &&
      !this.bountyPoolLocked(t) &&
      !t.finishTime
    );
  }

  isAtMaxPlayers(): boolean {
    const t = this.tournament;
    const max = t?.params?.maxPlayers;
    if (!max) return false;
    let players = t.playerCount || 0;
    if (t.params?.tournamentType === "reentry_tournament") {
      players -= t.live?.reentries || 0;
    }
    return players >= max;
  }

  canUnregister(): boolean {
    const t = this.tournament;
    if (!t) return false;
    const reg = t.params?.registrations;
    return (
      this.isRegistered() &&
      !this.amFinished() &&
      reg !== "fully_closed" &&
      !this.bountyPoolLocked(t) &&
      (reg !== "closed" || this.clubServ.clubStaff)
    );
  }

  registerTournament(): void {
    this.tournServ.registerForTournament(this.tournament.tournID);
  }

  unregisterTournament(): void {
    this.tournServ.unregisterFromTournament(this.tournament.tournID);
  }
}
